module.exports = __webpack_public_path__ + "static/media/hex_logo.d4a1557a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/details/imgs/hex_logo.png
// module id = 1158
// module chunks = 0